// ie 브라우저 호환성 관련 polyfill 추가
import '@babel/polyfill'
import Vue                          from 'vue';
import axios                        from 'axios';
import moment                       from 'moment';
import VueMomentJs                  from 'vue-momentjs';
import jQuery                       from 'jquery';
import Popper                       from 'popper.js';
import Fragment                     from 'vue-fragment';
import Toasted                      from 'vue-toasted';
import VueLogger                    from 'vuejs-logger';
import { router }                   from './router';
import store                        from './vuex/store';
import { i18n, loadLanguageAsync }  from './i18n';
/* SDL Base */
import SDLUtil                      from '@/utils/SDLUtil';
import SDLFilters                   from './filters';
import SDLDirectives                from './directives';
import SDLControl                   from './components/common/control';

/* Vue Componenets */
import SKPApp                       from './SKPApp';
/* SKP Services */
import api                          from '@/service';
/* Main CSS */
import '../static/css/common.css';
/* Toast Grid CSS */
import '../static/css/tui-grid.css';
/* Innorix CSS */
import '../static/js/innorix/innorix.css';

// third party libraries used in bootstrap
global.jQuery = jQuery;
global.$ = jQuery;
global.Popper = Popper;

Vue.use(VueMomentJs, moment);
Vue.use(Fragment.Plugin);
Vue.use(Toasted);

Vue.use(SDLFilters);    // Additional filters. common sdl
Vue.use(SDLControl);    // Additional components. common sdl
Vue.use(SDLDirectives); // Additional directives. common sdl

// logLevels :  ['debug', 'info', 'warn', 'error', 'fatal']
const isProd = process.env.NODE_ENV === 'prod';
const isDev  = process.env.NODE_ENV === 'dev';
const options = {
    isEnabled: true,
    logLevel : isProd ? 'error' : (isDev ? 'warn' : 'debug'),
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);

// Additional context
Vue.prototype.$CONTEXT  = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$context  = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$http     = axios;

Vue.config.productionTip = false;

// is prod devtool off
Vue.config.devtools = isProd ? false : true;

// cross domain issue (cors)
axios.defaults.baseURL = `${SDLUtil.API_URL}`;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

// ie, edge https://stackoverflow.com/a/45835054
axios.defaults.headers.common.Pragma = 'no-cache';

/*
 * 라이선스 유형 : INNORIX WP 웹 환경 파일전송 솔루션 60일 체험 (만료 2020-11-06)
 * 로컬 / 개발 서버용 라이센스, 만료일 확인 후 갱신 필요
 */
// INNORIX WP 개발 라이센스
// const expDate = '2025-04-30';
//const expDate = '2025-04-27';
//const expDate = '2025-07-28';
//const expDate = '2026-01-04';
//const expDate = '2026-05-20';
const expDate = '2026-08-22';
//const expDate = '2025-11-30';
// const expDate = '2025-01-31';
//const expDate = '2023-06-11';    // ke01.liu 20240405 change
//const expDate = '2024-06-30';    // dev change   pro do not need change
//window.innorix_license = "ER4FBw5azhdsyltTVHM8AIseiUM4KDHhqM37mj3i0VlX2Qc2+X6pVX1sSfmGA1eRetjXVDhg0/y3P1M2+PGbc7Qbp4c=";
//window.innorix_license = "tYZKWmP5S8VCzyVCaKwioya26BzRUAYdgNfZ9pQ7lBMYuhLNVsrIytt6MSL2/cNGNfxninO8mdUH+3PQMkLYhqPVixY=";
//window.innorix_license = "qihiVGi4IhrulU+Nqy+b6yWZy+TErIeBCDr96isvjwPNpdKcv6V3C+V+YMO/XZHL0vtm70PI4f0oUwK0Hano0DqtLSI=";//'2022-10-31';
//window.innorix_license = "M/Q0+EKD8cHpA3q+oZ0fS6sCcb5X+wZw7jAZfIc2UX1WEDkKHuF0JQQ/lboA0fZGCBFqSbZcBmobVsB9OqoKK7OQ1UI=";// ke01.liu 20241030 change
//window.innorix_license = "TblLOBM1z0hpDx/IQwT8CewHsP08p4xyRN4/4/UYgPOjLZgyBqJweZeJmvLOVpZ4JOf1weCC+gaJNmup1toGKkPcr24=";
// window.innorix_license = "x3VyepuLT5v00t7XGqEksVlQX4pAY3qJXKpTHLtAHobuS9pN+/TbyyLBluwVWkVlNifx1pYMn3N5/GqSzX7QcNnd780=";
// Test 542
// 2025-04-27
//window.innorix_license = "ct7OAJhxECRc6TZvc+FFCYNt0mNka+AQANvgKgkCezZsI0vyMbFJg0hgZ7Wh9nWKxiwYG68Vr+3+RaEHCg7ADtZaMUVR/uB8bhO2BvslArGv1IUVnd78w9+MxcUN9gddh+rn8k3M0GYqZCzE7IJC3mA8wkpBKWAveT9pIXy+mmlHEaSQW9nkJJcGR+PHva3vNtI/9VeKkSzSwMl25oC5AlR6LnN8KUZJ8GmkpFcjjzSkkzbOiEC54JGXK1W0dnANDU2o+eKL4xqnuVDOwrsZYWEOvFr1V/t7cTSx3yn6i9Svdfr7O5dwjXtE0yJFbrvgDxZKuqmyLVhLUPLmOA4cGg==";
//window.innorix_license = "aADmkRNwymM0v1976YC1ks0878ExP7L7qt/zEbZWwP3p4yoYW8DeRRqEBQ7u7PINiWrIUE/DS4RpShg0CibexhBu2HguIRp2D7NirrIw3RsW2u5aPwmOPzqccm/e0IuCQgJPDQLo31E+n9pCI2vXPWZfYh8YQee+1Q94Y8M6coXMyvZhl4WH1uEzWGUtxb4K52uut0nLkinf3A6n85zvuLXFQfX4ajdYjdYiBfZC/QlyPINWSUCtI9sr3ALmpTunlW4G1C6tbBVw63OzyXxJLztmYw7Ge4FAr8t3qRd0CPa17/4tcedTwOeFNShA4Tbv0uMbQ5FMLgVbozztqRPPJw==";
//window.innorix_license = "Ivv3TFWyiCFh6xcIWRXBXiDb55vzuOJZAl/ooIJ8xv9nznlSuVO9WMQCUHsxmRKXPH4CZJInVXFQHBX1tvtThxY2uKfuCdaDDvcGf+4tOfsN0kWdRrjVFU9W314/syk6r5QZ5NIOtIB4Ft/gPZ2S06xjNSlI00WivoUH9PfKeqMg8tbGL+/+eSjMJ00TSUsyafy+9jVsf35ecTSHc+sKQVd8wcul1fQOBrO3gR4pQYlf3v5VIcoLq7FXuZC//zIcM6CoAPf84THMG1LMkGejZiurd1r9ylBkxReqm7IzyjDmW7XNRUH1UIyZ0PUJ3STNXIbijHjnBVsOZ7oyYStVJw==";
//window.innorix_license = "W1AOxQ8AT2oAg9QRG9nLsj35FUMEYrcfMDKPqBKGcuqBd0DYN6D/73AWJQFTUqOf/GHPk+gfx72wUvb5JEwtgiRBTdB3WSFQcgICbKaq2NhA4StnbHq25nIJ50lsOmCH7mObsMCRTqGZlZ1ACNdj3ULk1y7YHGm4hhdfpSIRSXq5+0+H8Z70as8lWoQ2VsCvAip1Iu4AY1j2eV9NpfJ9XDqZC1EDePplSirJh0Hw5f9p+svSpnn9i4eLCEosA8jmOS2eEhkWj5t8JK1FrYRYRmKzjKP4E1j580RBJRPVJjUf+XuyACvFcW0h3TIjvPHmFGCYNNF/1wcofLUzupwswA==";
//window.innorix_license = "OUShAESUrbiNkxSTj5XybWDgsazPFEZfyM+LHZyh+M8OAy/cmMtZydg4I/18hiEQH6mJDprBSA9vepLp7FcpvTgEf7Q37aKXwq/3E7YSw66zkhWuY9PXHYi8MvlKjLuQ2snCSCkMZ9ZhJt3ByG1Ki/nZKK+HUXBs0biNtKMQBhgXjMmFqIDnFXTI5crivAlp+jCKd+9yxJPxFEY5vPune6reVrlJJfe10YuN1S4zhB1B25ZXOvs3kqgosXjjwhxGkCwYUx7mIYBkPUJkT0Bid3/xWzVdV28TqaMM2JhXaMPaJOTXtvoW2JYxX46szjBv82ad+QQnhXM3OUxl22lLwg==";
window.innorix_license = "Sr+1Oa5Vf3/Rq7rSaGsCZe5AOY8dot00G5n6jE6wBq/5aEaNWKRE/m5eLFe+FFzuQMwVzrHdm95utIfkwuTwaYIOpmsnW5k3MVxJnEwoZwykBOKBdp9AYnFo3mJc+v2BPzGvPzDQtO675DzjWdLRL4LlnoazgrcIAAHOVedcRKjQ8bXS3z1EebquuDYZoD0pvoW2j/Xz3gGR8eLshoHArrsEtjyXZG/t9i4aNsF1MwRbXbxe5H9ZcERh8KGnXh5QIiwYXkeAmg5EiOK4+gYc8QTaDKWAT2qBEEImr26cHRSlCaqdYk/j3MBQuYdxcubkUitrgXnvePrzFrr4UmgQow==";
//window.innorix_license = "/r3BvvmXUF7c7DoWdh79gXwR3RLg6udetBHTBsTflupJs9KaYtSsqvegqL6v+nqRb5GIvLPzk9mvIoP+/EaVyudK+qM=";   // ke01.liu 20240405 change
//dev change   pro do not need change
//window.innorix_license = "h17A0jcSJHmKV5qEVjZq+Rwd5clQAwEFviYUBb6yfyJHpD0mVKeVG8wk5fOxWo05q8gA4P17UrWp1lm8W1YGTF+frTUtLbQkjSVxFhho7CvMfppd133WFJZM5SB20ziWqCYFJs41FAUS2Ave6XwOg6DquZGSmokQlaQOqKfvYPRcCHu8t1y/SvI1oeLbY2IFTdksla6G+1eP2CvIEetCXlMxgOHFSZnQyJyMJW8EXloAq7D/GZxxZTpBzij8tSgv5JhjUkAGZnFO5tIYEGQn2Q8Ac20QLa1x9d5unmjpBGG1+qjbWon6xMPMvvVYj1hlKrBeCP34XaH2iL4BRQarHw==";

// 로컬 / 개발 서버인 경우, 이노릭스 만료일을 체크한다.
if(!isProd) {
    const innorixExpDate = moment(expDate, 'YYYY-MM-DD'),
          oneDay = 60 * 60 * 24 * 1000,
          sevenDay = 60 * 60 * 24 * 1000 * 7,
          toDate = moment();

    // 이노릭스 만료 하루 전 알림
    if((innorixExpDate.diff(toDate) <= oneDay) && (innorixExpDate.diff(toDate) > 0)) {
        Vue.$log.warn('INNORIX WP 개발 라이센스 만료 하루 전 - expire date : ', innorixExpDate.format('YYYY-MM-DD'));
        alert('INNORIX WP 개발 라이센스 만료 하루 전 - expire date : ' + innorixExpDate.format('YYYY-MM-DD'));

    // 이노릭스 만료 일주 전 알림
    } else if((innorixExpDate.diff(toDate) <= sevenDay) && (innorixExpDate.diff(toDate) > 0)) {
        Vue.$log.warn('INNORIX WP 개발 라이센스 만료 일주 전 - expire date : ', innorixExpDate.format('YYYY-MM-DD'));
        alert('INNORIX WP 개발 라이센스 만료 일주 전 - expire date : ' + innorixExpDate.format('YYYY-MM-DD'));

    // 이노릭스 만료 시
    } else if(innorixExpDate.diff(toDate) <= 0) {
        Vue.$log.error('INNORIX WP 개발 라이센스 만료 - expire date : ', innorixExpDate.format('YYYY-MM-DD'));
        alert('INNORIX WP 개발 라이센스 만료 - expire date : ' + innorixExpDate.format('YYYY-MM-DD'));
    };

/*
 * npm run build-prod 실행 시, 이노릭스 라이센스는 아래 URL에 적용된다.
 * http://scms.sec.samsung.net
 * http://skpupload.samsungcsportal.com
 * http://skp.samsungcsportal.com
 */
} else if(isProd) {
    // 운영 이노릭스 라이센스, 절대 수정하지 말 것!
    // window.innorix_license = "XWdszO/2D7nJbqdVicreAxkDA8WXcxwaPy02W0H8ImJmGYPGctLDZb/tz6a5/LVRshgVofB/O+OvjOCWeQrw1L2xxO021Jckf5vhkS3+hy2w9zO/yAv97d1sWhburJTNPjduge45G+svG6OepfsQ0N5Eayehj3ugFnFuge45G+svG0/7QI5XUloJ1SU=";
    window.innorix_license = "M7r7ka/W8idbD53NbhBxHxvW/v+mq8wX3NwIc0KsfyyCPShnhQ/lMxustDXXb6whf+AKtFq2ZTYOYgMMKrw+MQmb7K/Zetn0mqPsNfnKSVWYbzhBbkz8sBP65pNC6vQmw5SEXo+qkkXbI8LvdCVh2ryQut5lIUWHRRNm4wE31QatNPQNPKiroXQ9EXw+99qdGa2G6nBHJXRkTJrhHAdhQ2mbH8UcLUCr0HtPbjAO7iY6Yn7lnmCxC5XYCBIo6C8RdMXxI0TTQF0KVL+3t2O3TCgIN2rNRgnwZxwMGQoSUbl9D09yzusvAG4yX9wxUIePlF6q7GsAOuVZe3OjUVanKQ==";
};

// request interceptor
axios.interceptors.request.use(
    config => {
        if(store.getters.getToken !== null && config.headers.common['x-auth-token'] == null) {
            Vue.$log.info('◎ axios set request header \'X-AUTH-TOKEN\' => ', store.getters.getToken);
            axios.defaults.headers.common['x-auth-token'] = store.getters.getToken;
        }

        axios.defaults.headers.common['last-access-time'] = localStorage.getItem('lastAccessTime');
        // Vue.$log.info('request:', localStorage.getItem('lastAccessTime'));
        // Do something before request is sent
        return config;
    },
    error =>
        // Do something with request error
        Promise.reject(error),
);

// response interceptor
axios.interceptors.response.use(
    async (response) => {
        if (response.headers.date !== null && response.headers.date !== '') {
            let lastAccessTime = new Date(response.headers.date).getTime();
            localStorage.setItem('lastAccessTime', lastAccessTime);
            //Vue.$log.info('resonse:', response.headers.date, localStorage.getItem('lastAccessTime'));
        }

        // Response include error object
        if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
            // exeption of Translate api
            if(response.config.url.indexOf('/basis/common/translate.skp') > -1) {
                return response;
            }

            Vue.$log.info('◎ Response contain Error object =>', response.data.error);

            // const errCode = response.data.error.code;
            // Add code number below if error message is passed to login after error message during certain error code
            const loginErrCodes = ['187', '191', '192', '193', '194', '195', '199', '200', '401', '403', 'REDIRECT'];
            const hhpErrCodes = ['HHP_NO_CERTINFO', 'HHP_CERT_REQUIRED', 'HHP_FORBIDDEN', 'HHP_LOGIN_REQUIRED'];

            // 500 is excluded for error checking when localhost.
            if (window.location.hostname !== 'localhost') { loginErrCodes.push('500'); }

            // loginErrCodes 처리
            if (loginErrCodes.includes(String(response.data.error.code))
                && router.currentRoute.fullPath.indexOf('/no_auth') === -1)
            {
                SDLUtil.showLoadingBar(true);
                Vue.$log.error(`◎ Response error code => ${response.data.error.code}`, `${response.data.error.message}`);
                // Do not process logout when there is a general error
                if(String(response.data.error.code === '200')) {
                    SDLUtil.showLoadingBar(false);

                    // BaseController 에서 ErrorHandler 를 통해 던져진 메세지인 경우 ( 최초 구상은 권한없음 페이지 였지만, axios 환경에서 원할한 이동을 위해 에러로 변경 )
                    if (response.data.error.message === 'MESSAGE.AUTHORITY.NOHAVE') {
                        let msg = SDLUtil.getMsgProp(response.data.error.message);
                        /*
                        if(!alert(msg.replace('<br>', '\n\n'))) {
                        	api.logout();
                        	return router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/no_auth` });
                        };
                        */
                        return Promise.reject(
                            Object.assign(
                                response, new Error(response.data.error.message),
                            ));

                    // SKPAccessFilter 에서 UserContainer가 없는 경우 던지는 메세지가 맞다면, 세션 만료 페이지로 이동
                    } else if (response.data.error.message === 'MESSAGE.SESSION.HAS.EXPIRED') {
                        Vue.$log.warn(`◎ Session has expired => /no_session`);
                        return router.push({ name: 'NoSession' });
                    }

                } else if (String(response.data.error.code) === 'REDIRECT') {
                    SDLUtil.showLoadingBar(false);
                    return router.push({path: response.data.error.message }); // = response.data.error.message;

                } else if (String(response.data.error.code) !== '500') {
                    SDLUtil.showLoadingBar(false);
                    // return api.logout();
                    // return router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/no_auth` });

                    return Promise.reject(
                        Object.assign(
                            response, new Error(response.data.error.message),
                        ));

                } else {
                    SDLUtil.showLoadingBar(false);
                    return router.push({ name: 'Error' });
                }
            }

            if (hhpErrCodes.includes(String(response.data.error.code))) {
                // Vue.$log.error('HHP Cert Error', response.data.error);
                if (response.data.error.code === 'HHP_FORBIDDEN') {
                    router.push({path: '/basis/certificate/CertWarning'}); // = response.data.error.message;

                    return Promise.reject(
                        Object.assign(
                            response, new Error(response.data.error.message),
                        ));

                // } else if (response.data.error.code === 'HHP_CERT_REQUIRED') {
                //     return router.push({path: '/basis/certificate/CertLogin'}); // = response.data.error.message;
                }


                // return Promise.reject(
                //     Object.assign(
                //         response, new Error(response.data.error.message),
                //     ));
            }

            return Promise.reject(
                Object.assign(
                    response, new Error(response.data.error.message),
                ));
        }

        return response;
    },
    error => Promise.reject(error),
);

const lang = (window.navigator.userLanguage || window.navigator.language || 'ko-KR')
        .replace('-', '_').split('_')[0];

loadLanguageAsync(lang)
    .then(() => {

	//CB 중간 페이지
	var agent = navigator.userAgent.toLowerCase();
    //console.log("agent", agent);
    if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) ) {
        //alert("인터넷 익스플로러 브라우저 입니다.");
        location.href = "/browser.html";
    } else {
        new Vue({
            router,
            store,
            i18n,
            render : h => h(SKPApp),
        }).$mount('#app');
    }

    })
    .catch(err => {
        Vue.$log.error('◎ SKP App Main server catch error =>', err);
        // LEGO -> Server error
        if(err.toJSON && typeof err.toJSON === 'function') {
            let e = err.toJSON();
            // check "Network Error"
            Vue.$log.error(e);
            if( e.message === 'Network Error') {
                window.location.href = "/static/html/connection_not_found_error.html";
                return;
            }

        } else {
            Vue.$log.error("◎ catch error", err);
        }
    });



// WEBPACK FOOTER //
// ./src/main.js